var map = {
	"./menu-item-0.svg": "63c8",
	"./menu-item-1 2.svg": "6806",
	"./menu-item-1.svg": "5594",
	"./menu-item-2 2.svg": "f250",
	"./menu-item-2.svg": "8394",
	"./menu-item-3.svg": "b0b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b135";